import React, { useEffect } from "react";
import images from "../images/junaid.jpeg";
import About from "./about";
import Services from "./services";
// import Connect from "./connect";
import Skill from "./skill";
import Blog from "./blog";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";
import Latest from "./Latest";

const Hero = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      <header
        className="hero"
        id="Home"
        data-aos="fad-in"
        data-aos-anchor-placement="top-bottom"
      >
        <div id="stripes">
          <span data-aos="fade-up"></span>
          <span data-aos="fade-down"></span>
          <span data-aos="fade-up"></span>
          <span data-aos="slide-left"></span>
          <span data-aos="slide-right"></span>
        </div>
        <div className="section-center hero-center">
          <artical className="hero-info">
            <div className="underline" data-aos="fade-in"></div>

            <h1 data-aos="fade-in">I'm Junaid</h1>
            <motion.h4
              className="hh"
              initial={{ x: "-100px", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ y: "-40px", opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              Full Stack Web Developer
            </motion.h4>
            <Link to="/contact">
              <motion.button
                className="btn hero-btn"
                whileHover={{
                  scale: 1,
                  boxShadow: "0px 0px 15px #ca9c9c",
                  textShadow: "0px 0px 15px #b83455",
                }}
              >
                Hire Me
              </motion.button>
            </Link>
            <ul className="social-icons hero-icons hi" data-aos="fade-in">
              <li>
                <a
                  href="https://www.facebook.com/junaid4u.ahmad"
                  className="social-icon a"
                >
                  <i className="fab fa-facebook"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/juac08/"
                  className="social-icon a"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="https://github.com/juac08" className="social-icon a">
                  <i class="fab fa-github"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com" className="social-icon a">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </artical>
          <artical className="hero-img main">
            <img
              src={images}
              alt="Junaid Ahmad"
              className="hero-photo"
              data-aos="fade-in"
            />
          </artical>
        </div>
      </header>
      <About />
      <Latest />
      <Services />
      {/* <Connect /> */}
      <Skill />
      <Blog />
    </>
  );
};

export default Hero;
